module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Rose_diameter.976319ab.png";